export default {"src":"/_next/static/media/fast_and_direct_banking.2649e0c5.svg","height":262,"width":366,"blurWidth":0,"blurHeight":0};